var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6172 0H3.03795C1.36184 0 0 1.38089 0 3.07605V39.5886C0 41.2838 1.36184 42.6647 3.03795 42.6647H39.6172C41.2933 42.6647 42.6647 41.2838 42.6647 39.5886V3.07605C42.6647 1.38089 41.2933 0 39.6172 0ZM12.8946 36.5697H6.57112V16.2088H12.9042V36.5697H12.8946ZM9.73288 13.4279C7.7044 13.4279 6.06638 11.7804 6.06638 9.76145C6.06638 7.74249 7.7044 6.09495 9.73288 6.09495C11.7518 6.09495 13.3994 7.74249 13.3994 9.76145C13.3994 11.7899 11.7614 13.4279 9.73288 13.4279ZM36.5983 36.5697H30.2748V26.6654C30.2748 24.3036 30.2272 21.2657 26.9892 21.2657C23.6941 21.2657 23.1894 23.837 23.1894 26.494V36.5697H16.8659V16.2088H22.9323V18.9896H23.018C23.8655 17.3897 25.9321 15.704 29.0082 15.704C35.4079 15.704 36.5983 19.9229 36.5983 25.4083V36.5697Z",
    fill: "url(#paint0_linear_203_4008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_4008",
    x1: 0,
    y1: 42.6647,
    x2: 42.6647,
    y2: 42.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5773FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4992ee7c2a3a2e6225136518b75899b8.svg";
export { ForwardRef as ReactComponent };